import { useLocation } from 'react-router-dom'
import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import type { FlightsClassTypes } from 'constants/flight'
import { CHARTER_PREVIEW_CHECK_IN, CHARTER_PREVIEW_CHECK_OUT } from 'lib/charterFlights/charterBundleRecommendation'
import useCharterBundleRecommendation from './useCharterBundleRecommendation'

interface Options {
  offer: App.HotelOffer
  rooms: Array<App.Occupants>
  fareClass: FlightsClassTypes
  duration: number
  checkIn?: string
  charterBundleRoute?: App.CharterBundleRoute
}

/** A cross-sell preview never writes to the customer's hotel date selection. */
export default function useCharterBundleFlightPreview({ offer, rooms, fareClass, duration, checkIn, charterBundleRoute }: Options) {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const previewCheckIn = params.get(CHARTER_PREVIEW_CHECK_IN)
  const previewCheckOut = params.get(CHARTER_PREVIEW_CHECK_OUT)
  const valid = !!charterBundleRoute && !checkIn && !!previewCheckIn && !!previewCheckOut &&
    moment(previewCheckIn, ISO_DATE_FORMAT, true).isValid() && moment(previewCheckOut, ISO_DATE_FORMAT, true).isValid()
  const { candidates } = useCharterBundleRecommendation({ offer, rooms, duration, fareClass, disabled: !valid })
  return valid ? candidates.find(candidate => candidate.checkIn === previewCheckIn && candidate.checkOut === previewCheckOut && candidate.nights === duration) : undefined
}
